// extracted by css-extract-rspack-plugin
export default {"marqueeContainer":"MarqueeText-module__marqueeContainer","marqueeContent":"MarqueeText-module__marqueeContent","marquee":"MarqueeText-module__marquee"};